import axios from "axios";
import Vue from "vue";

const disabledToastUrl = ["Account/login", "Account/resetPassword", "Account/changePassword"];
const apiHttpClient = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  withCredentials: false, // This is the default
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});
apiHttpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (disabledToastUrl.indexOf(error.config.url) === -1) {
      if (error.response.data === "InvalidStartTime") {
        Vue.prototype.$toast.add({
          severity: "warn",
          summary:
            "Er bestaat al een registratie met dezelfde starttijd / Invalid Start time",
          life: 3000,
          closable: false,
        });
      } 
      else if (error.response.data === "InvalidEndTime") {
        Vue.prototype.$toast.add({
          severity: "warn",
          summary:
            "Er bestaat al een registratie met dezelfde eindtijd / Invalid End time",
          life: 3000,
          closable: false,
        });
      }
      else if (error.response.data === "InvalidStartTimeForNextWorkDay") {
        Vue.prototype.$toast.add({
          severity: "warn",
          summary:
            "Er bestaat al een registratie met dezelfde starttijd / Workregistrations overlapped",
          life: 3000,
          closable: false,
        });
      } else {
        Vue.prototype.$toast.add({
          severity: "error",
          summary: "An error has occurred",
          life:5000,
          group:"generalError",
          closable: true,
        });
      }
    }
    throw error;
  }
);

apiHttpClient.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem("authtoken");

    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },

  (error) => {
    if (disabledToastUrl.indexOf(error.config.url) === -1) {
      Vue.prototype.$toast.add({
        severity: "error",
        summary: "An error has occured",
        life: 3000,
        closable: false,
      });
    }
    return Promise.reject(error);
  }
);

export default apiHttpClient;
